import { render, staticRenderFns } from "./TrunkFeaturesChart.vue?vue&type=template&id=223238b8&scoped=true&"
import script from "./TrunkFeaturesChart.vue?vue&type=script&lang=js&"
export * from "./TrunkFeaturesChart.vue?vue&type=script&lang=js&"
import style0 from "./TrunkFeaturesChart.vue?vue&type=style&index=0&id=223238b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223238b8",
  null
  
)

export default component.exports